export const en = {
    weeklyRewards: 'Weekly rewards in',
    days: 'days',
    hours: 'hours',
    minutes: 'mins',
    seconds: 'secs',
    authenticating: 'Authenticating',
    verifyWallet: 'Please wait while we verify your wallet',
    authRequired: 'Authentication Required',
    authFailed: 'Authentication failed. Please try again.',
    points: 'Points',
    rank: 'Rank',
    of: 'of',
    players: 'players',
    weeklyTopPlayers: 'Weekly Top Players',
    thisWeekLeaderboard: "This Week's Leaderboard",
    rankingsReset: 'Rankings reset every Sunday at midnight UTC',
    yourPoints: 'Your Points',
    dailyRewardAvailable: 'Daily Reward Available!',
    nextClaimAvailable: 'Next Claim Available In:',
    claimDailyReward: 'Claim Daily Reward',
    claiming: 'Claiming...',
    multiplier: 'Multiplier',
    bonusPointsMultiplier: 'Bonus points multiplier',
    outOf: 'out of',
    loading: 'Loading...',
    errorLoading: 'Error loading',
    noEntries: 'No entries yet',
    leaderboard: 'Leaderboard',
    tasks: 'Tasks',
    rules: 'Rules',
    profile: 'Profile',
    comingSoon: 'Coming soon...',
    completedTasks: 'Completed\nActivities',
    dailyRewardsClaimed: 'Daily Rewards Claimed',
    times: 'times',
    recentActivity: 'Recent Activity',
    noRewardsClaimed: 'No rewards claimed yet',
    dailyReward: 'Daily Reward',
    howItWorks: 'How It Works',
    welcomeMessage:
        'Welcome to Coinomi Rewards! Earn points by completing various tasks and climb the leaderboard.',
    dailyRewardsTitle: 'Daily Rewards',
    dailyRewardsRules: [
        'Claim your daily reward every 24 hours',
        'Each claim gives you 100 points',
        'Points are multiplied based on your multiplier',
    ],
    multiplierBonusesTitle: 'Multiplier Bonuses',
    multiplierBonusesRules: [
        'Start with a 1x multiplier',
        'Connect Telegram for +10% bonus',
        'Verify email for +10% bonus',
        'Bonuses stack for maximum rewards',
    ],
    leaderboardTitle: 'Leaderboard',
    leaderboardRules: [
        'Compete with other players',
        'Rankings update in real-time',
        'Top players earn special rewards',
    ],
    boostEarningsTitle: 'Boost Your Earnings',
    boostEarningsRules: [
        'Complete challenges to earn bonuses',
        'Join our Telegram community',
        'Stay active to maximize your rewards',
    ],
    challenges: 'Challenges',
    telegramChallenge: 'Telegram Challenge',
    emailChallenge: 'Email Challenge',
    connectTelegram: 'Connect with Telegram',
    shareEmail: 'Share Email',
    telegramSuccess:
        '🎉 Congratulations! You are now receiving a permanent 10% bonus on all rewards!',
    telegramPrompt: 'Link your Telegram account to get a permanent 10% bonus on all rewards!',
    emailSuccess: '🎉 Congratulations! You are now receiving a permanent 10% bonus on all rewards!',
    emailPrompt: 'Share your email to get a permanent 10% bonus on all rewards!',
    connectEmail: 'Connect Email',
    cancel: 'Cancel',
    emailPrivacy: "We'll only use your email for important updates and rewards notifications.",
    connectYourEmail: 'Connect Your Email',
    emailBonus: '🎉 Get a permanent 10% bonus on all rewards by connecting your email!',
    enterValidEmail: 'Please enter a valid email address',
    hallenges: 'Challenges',
    emailChallengePrompt: 'Share your email to get a permanent 10% bonus on all rewards!',
    emailChallengeSuccess:
        '🎉 Connected! You are now receiving a permanent 10% bonus on all rewards!',
    emailAddress: 'Email Address',
    errorSavingEmail: 'Error saving email. Please try again.',
    claimButton: 'Claim',
    earnedReward: 'Earned Reward',
    rewardValue: '{{amount}} Points',
    claimSuccess: 'Successfully claimed {{amount}} points!',
    claimError: 'Failed to claim reward. Please try again.',
    privacyDisclaimer:
        'Coinomi does not collect personal data; a third-party system securely manages points and social linking.',
    streakBonus: 'Streak Bonus',
    streakDays: '{{days}}/5 Days',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Extra',
    streakDescription: 'Claim 5 days in a row for maximum bonus',
    streakToday: 'Today',
    streakMissed: 'Missed',
    streakComplete: 'Complete',
    streakActive: 'Active Streak',
    streakLost: 'Streak Lost',
    streakNext: 'Next',
    home: 'Home',
    currentStreak: 'Current Streak',
    totalClaims: 'Total Claims',
    userStats: 'Your Stats',
    referrals: 'Referrals',
    referralProgram: 'Referral Program',
    howReferralWorks: 'How Referrals Work:',
    referralSteps: [
        'Share your referral link with friends',
        'When they join using your link, they become your referral',
        'Earn bonus points for each active referral',
        'Track your referrals and earnings here',
    ],
    referralRewards: 'Referral points are granted:',
    referralBonuses: [
        '100 points when you affiliate someone',
        '10% of every points the referral gets',
    ],
    yourReferralLink: 'Your Referral Link',
    copyToClipboard: 'Copy to clipboard',
    linkCopied: 'Link copied to clipboard!',
    totalReferrals: 'Total Referrals',
    yourReferralCode: 'Your Referral Code',
    referralCodeCopied: 'Referral code copied!',
    editReferralCode: 'Edit Referral Code',
    editReferralCodeInstructions:
        'Choose a new referral code. It must be at least 5 characters long and can contain letters and numbers.',
    newReferralCode: 'New Referral Code',
    referralCodeRequirements: 'Minimum 5 characters, letters and numbers only',
    updating: 'Updating...',
    update: 'Update',
    referralCodeTaken: 'This referral code is already taken',
    haveReferralCode: 'Have a Referral Code?',
    enterReferralCodePrompt:
        'If someone referred you, enter their code here to connect your accounts.',
    enterReferralCode: 'Enter Referral Code',
    enterReferralCodeInstructions: 'Enter the referral code shared with you.',
    referralCode: 'Referral Code',
    referralCodeFormat: 'Letters and numbers only',
    submitting: 'Submitting...',
    submit: 'Submit',
    enterCode: 'Enter Code',
    // Error Page Messages
    pleaseAddtoken: 'Please add a token parameter to the URL',
    pleaseAddUserId: 'Please add a userId parameter to the URL',
    authenticationError: 'An error occurred during authentication',
    noUserFound: 'No User Found',
    userNotFoundMessage: 'Could not find user data',
    backToHome: 'Back to Home',
    retry: 'Retry',
    // Multiplier
    baseMultiplier: 'Base Multiplier',
    telegramBonus: 'Telegram Bonus',
    // Referral Challenge
    referralChallenge: 'Referral Challenge',
    referralChallengePrompt:
        'Invite friends and earn bonus points! Get 100 points for each referral plus 10% of their earnings.',
    startReferring: 'Start Referring',
    referralSuccess:
        '🎉 Congratulations! You have successfully referred users and are earning bonus points!',
    unranked: 'Unranked',
    noPlayersYet: 'Be the first to join!',
    // Social Sharing
    shareVia: 'Share via',
    shareOn: 'Share on {{network}}',
    shareInviteText:
        "🚀 I'm earning free crypto with @CoinomiWallet!\n\nDownload Coinomi at coinomi.com/downloads and enter my referral code {{referralCode}} to get a bonus when you join #Coinomi Rewards in the app.",
    yourStatsThisWeek: 'Your stats this week',
    pointsMultiplier: 'Points\nmultiplier',
    yourRank: 'Your\nrank',
    rewards: 'Rewards',
    daily: 'Daily',
    weekly: 'Weekly',
    claimRewards: 'Claim rewards',
    // Privacy Disclaimer
    privacyTitle: 'Coinomi does not collect personal data',
    privacyDescription: 'A third-party system securely manages points and social linking.',

    // Wallet Info
    walletAddress: 'Wallet Address',

    // Theme Toggle
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',

    pointsAvailable: 'Points available',

    player: 'Player',
    score: 'Score',

    youHaveReferred_zero: "You haven't referred any friends yet",
    youHaveReferred_one: 'You have referred 1 friend',
    youHaveReferred_other: 'You have referred {{count}} friends',
    referYourFriends: 'Refer Your Friends',
    dailyRewardTooltip: 'Come back every day to claim your points & rewards',
    weeklyRewardTooltip: 'Reward airdrops are distributed on a weekly basis',

    // Leaderboard translations
    topPerformers: 'Top performers for the selected period',
    week: 'Week',
    year: 'Year',

    // Recent Activity translations
    'new-referral': 'New Referral',
    'daily-reward': 'Daily Reward',
    'referral-bonus': 'Referral Bonus',
    copy: 'Copy',

    // Twitter Challenge
    twitterChallenge: 'Twitter Challenge',
    connectTwitter: 'Connect with Twitter',
    twitterSuccess:
        '🎉 Congratulations! You are now receiving a permanent 10% bonus on all rewards!',
    twitterPrompt: 'Link your Twitter account to get a permanent 10% bonus on all rewards!',
    twitterAuthSuccessTitle: 'Twitter Connected Successfully!',
    twitterAuthSuccessMessage:
        'You have successfully connected your Twitter account. You can now continue using the app.',
    continueToApp: 'Continue to App',
    twitter_like: 'Liked a tweet',
    twitter_retweet: 'Retweeted a tweet',
    followKoalaWalletChallenge: 'Follow @coinomiWallet on Twitter to support us!',
    disconnect: 'Disconnect',
    followCoinomiWallet: 'Follow @coinomiWallet on Twitter to support us!',
    connectedBonus: '🎉 Connected! You are now receiving a permanent 10% bonus on all rewards!',
    // KPI Dashboard
    kpiDashboard: 'KPI Dashboard',
    totalUsers: 'Users',
    twitterConnected: 'Twitter Connected',
    telegramConnected: 'Telegram Connected',
    emailConnected: 'Email Connected',
    recentRegistrations: 'Registrations 7d',
    activeUsers: 'Active 7d (profile)',
    activeUsersByScore: 'Active 7d (activity)',
    totalTasks: 'Total Tasks',
    totalRewards: 'Total Rewards',
    totalPoints: 'Points Distributed',
    topUser: 'Top User (7d)',
    engagementByType: 'Engagement by Reward Type (7d)',
};
